import classNames from 'classnames';
import React from 'react';
import FontAwesome from 'react-fontawesome';
import type { ReactChildren } from 'types/utility';
import styles from './InputLabel.module.scss';

interface Props extends React.HTMLAttributes<HTMLLabelElement> {
  children: ReactChildren;
  required?: boolean;
  /** Display label as inline-block? Defaults to block */
  inline?: boolean;
}

const InputLabel: React.FC<Props> = ({ children, inline, required, ...rest }) => {
  const containerClass = classNames(
    styles.container,
    { [styles.isRequired]: required },
    { [styles.inline]: inline },
    rest.className
  );
  return (
    <label {...rest} className={containerClass}>
      {children}
      {!!required && (
        <span className={styles.icon}>
          <FontAwesome name="exclamation-triangle" />
        </span>
      )}
    </label>
  );
};

InputLabel.defaultProps = {};

export default React.memo(InputLabel);
